import styled from 'styled-components'
import { theme } from '../../styles'

export const TopBarRoot = styled.header`
  position: sticky;
  top: 0;
  z-index: 40;
  background: rgba(246, 241, 231, 0.82);
  backdrop-filter: saturate(1.4) blur(10px);
  -webkit-backdrop-filter: saturate(1.4) blur(10px);
  border-bottom: 1px solid ${theme.cores.line};

  ${theme.mobile} {
    background: rgba(246, 241, 231, 0.94);
    backdrop-filter: saturate(1.4) blur(12px);
    -webkit-backdrop-filter: saturate(1.4) blur(12px);
  }
`

export const Container = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
  height: 74px;
  display: flex;
  align-items: center;
  gap: 22px;

  ${theme.mobile} {
    height: 56px;
    padding: 0 18px;
    gap: 12px;
  }
`

export const Logo = styled.img`
  height: 42px;
  width: auto;
  display: block;

  ${theme.mobile} {
    height: 32px;
  }
`

export const Nav = styled.nav`
  display: flex;
  gap: 4px;
  margin-left: 14px;

  ${theme.mobile} {
    display: none;
  }
`

export const NavLink = styled.a`
  color: ${theme.cores.inkDeep};
  text-decoration: none;
  padding: 8px 14px;
  border: 0;
  background: transparent;
  border-radius: 999px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;

  ${( { $active } ) => $active && `
    background: rgba(38, 42, 95, 0.07);
    color: ${theme.cores.navy};
  `}

  &:hover {
    background: rgba(38, 42, 95, 0.06);
    color: ${theme.cores.navy};
  }
`

export const MemberWrap = styled.div`
  position: relative;
  margin-left: auto;
`

export const Member = styled.button`
  display: flex;
  align-items: center;
  gap: 11px;
  background: ${theme.cores.card};
  border: 1px solid ${theme.cores.line};
  border-radius: 999px;
  padding: 5px 6px 5px 14px;
  cursor: pointer;
  font-family: inherit;
  transition: border-color 0.2s ease, background 0.2s ease;

  &:hover {
    border-color: ${theme.cores.lineStrong};
  }

  ${theme.mobile} {
    padding: 4px 5px 4px 11px;
    gap: 9px;
  }
`

export const MemberChevron = styled.span`
  display: inline-flex;
  color: ${theme.cores.inkFaint};
  transition: transform 0.2s ease;
  transform: rotate(${( { $open } ) => ( $open ? '180deg' : '0deg' )});

  ${theme.mobile} {
    display: none;
  }
`

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 180px;
  padding: 6px;
  background: ${theme.cores.card};
  border: 1px solid ${theme.cores.line};
  border-radius: 12px;
  box-shadow: ${theme.sombras.lg};
  z-index: 50;
`

export const DropdownItem = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-radius: 8px;
  background: none;
  color: ${theme.cores.inkDeep};
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: ${theme.cores.paperAlt};
  }
`

export const DropdownItemMobileOnly = styled( DropdownItem )`
  display: none;

  ${theme.mobile} {
    display: flex;
  }
`

export const DropdownDivider = styled.hr`
  display: none;
  border: 0;
  border-top: 1px solid ${theme.cores.line};
  margin: 6px 4px;

  ${theme.mobile} {
    display: block;
  }
`

export const MemberInfo = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${theme.mobile} {
    display: flex;
  }
`

export const MemberName = styled.span`
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: ${theme.cores.inkDeep};
  line-height: 1.1;

  ${theme.mobile} {
    font-size: 13px;
    max-width: 96px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const MemberPlan = styled.span`
  display: block;
  font-size: 11.5px;
  color: ${theme.cores.inkFaint};
  line-height: 1.2;

  ${theme.mobile} {
    font-size: 11px;
  }
`

export const Avatar = styled.span`
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: ${theme.cores.navy};
  color: ${theme.cores.white};
  font-family: ${theme.fontes.serif};
  font-size: 14px;
  font-weight: 700;

  ${theme.mobile} {
    width: 32px;
    height: 32px;
    font-size: 13px;
  }
`
